import { Button, Dropdown, Form, Modal, Spinner } from "react-bootstrap";
import { projectPrimaryColor } from "../../generalConfigs";
import { useState } from "react";
import { IoWalletOutline } from "react-icons/io5";
import { GiFireShield } from "react-icons/gi";
import { MdDone } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { BiError } from "react-icons/bi";
import useWallet from "../../hooks/useWallet";
import Swal from "sweetalert2";
import { AiOutlineClose } from "react-icons/ai";

enum eStep {
    WELCOME,
    IMPORT_EXCEL,
    TOLERANCE,
    DONE,
    ERROR,
}

export default function SetupWalletB3() {
    const [step, setStep] = useState<eStep>(eStep.WELCOME);
    const [tolerance, setTolerance] = useState<string>("low");
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [canContinueFile, setCanContinueFile] = useState<boolean>(false);

    const { upsertWalletB3 } = useWallet();
    const { push } = useHistory();

    async function handleSubmit() {
        if (!file) {
            return;
        }

        setIsLoading(true);

        const statusCode = await upsertWalletB3(file, tolerance);

        if (statusCode === 201) {
            setStep(eStep.DONE);
        } else {
            setStep(eStep.ERROR);
        }

        setIsLoading(false);
    }

    function handleFileChange(event: any) {
        if (isLoading) {
            return;
        }
        event.preventDefault();
        const file = event?.target?.files?.[0];

        if (event.target.files) {
            if (file && file.name.includes('.xlsx')) {
                setFile(file);
                setCanContinueFile(true);
            } else {
                Swal.fire({
                    title: "Arquivo inválido",
                    text: 'Por favor, selecione um arquivo .xlsx',
                    icon: "error",
                    confirmButtonColor: projectPrimaryColor,
                    background: "var(--bg-1)",
                    color: "var(--text-1)",
                    position: 'top'
                });
                setCanContinueFile(false);
                return;
            }
        }
    }



    function modalBody() {
        if (step === eStep.WELCOME) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <IoWalletOutline
                        style={{ color: "var(--primary-blue)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Configure sua carteira.
                </h1>
                <p className="tx-15 text-center tx-light">
                    Pronto para definir as novas configurações da sua carteira e treinar a IA? É bem simples, clique no botão abaixo para continuar.
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => setStep(eStep.IMPORT_EXCEL)}>
                        Próximo
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.IMPORT_EXCEL) {
            return <Modal.Body>
                <h1 className="text-center">
                    Importe sua posição B3
                </h1>
                <p className="text-center">Importe o arquivo Excel da área de investidor B3 (Posição/Investimentos) que contém os detalhes dos seus investimentos.</p>
                <a className="text-center tx-18" href="https://mycapital.movidesk.com/kb/pt-br/article/247666/portal-b3-como-emitir-o-relatorio-de-posicao-no-formato-xls" target="_blank">Clique aqui caso não saiba como encontrar o arquivo</a>
                <Form.Label className="mg-t-20">Selecione um arquivo .xlsx</Form.Label>
                <div className="d-flex justify-content-center">
                    <input
                        className="btn btn-primary rounded-button"
                        onChange={(e) => handleFileChange(e)}
                        type="file"
                    />
                </div>

                <div className="d-flex justify-content-center mg-t-20">
                    <Button disabled={!canContinueFile} className="btn btn-primary font-weight-bold rounded-md" onClick={() =>
                        setStep(eStep.TOLERANCE)
                    }>
                        Próximo
                    </Button>
                </div>
            </Modal.Body >
        } else if (step === eStep.TOLERANCE) {

            return <Modal.Body>
                <h1 className="text-center">
                    Defina sua tolerância
                </h1>
                <p className="text-center">Este dado se refere à sua tolerância para perdas, nossa IA vai utilizar estes dados para personalizar suas análises.</p>

                <Form.Label>Tolerância á perdas</Form.Label>
                <Dropdown>
                    <Dropdown.Toggle className="rounded-button wd-100p" variant="secondary">
                        {parseTolerance(tolerance)}
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ backgroundColor: 'var(--bg-1)' }} className="wd-100p">
                        <Dropdown.Item
                            className="dropdown-item-selectable text-center cursor-pointer"
                            onClick={() => setTolerance('high')}
                        >
                            <GiFireShield color="var(--green)" size={30} />
                            <span className="mg-l-10">ALTA</span>
                        </Dropdown.Item>

                        <Dropdown.Item
                            className="dropdown-item-selectable text-center cursor-pointer"
                            onClick={() => setTolerance('low')}
                        >
                            <GiFireShield color="var(--red)" size={30} />
                            <span className="mg-l-10">BAIXA</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                <div className="d-flex justify-content-center mg-t-20 gap-8">
                    <Button className="btn btn-secondary rounded-md" onClick={() => {
                        setStep(eStep.IMPORT_EXCEL)
                    }}>
                        Voltar
                    </Button>

                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => handleSubmit()}>
                        Finalizar
                    </Button>
                </div>
            </Modal.Body>
        }
        else if (step === eStep.DONE) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <MdDone
                        style={{ color: "var(--success)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Sucesso
                </h1>
                <p className="tx-15 text-center tx-light">
                    Sua carteira foi configurada com sucesso, clique no botão abaixo para acesssar
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => push('/wallet-b3')}>
                        Acessar
                    </Button>
                </div>
            </Modal.Body>
        } else if (step === eStep.ERROR) {
            return <Modal.Body>
                <div className="d-flex justify-content-center">
                    <BiError
                        style={{ color: "var(--danger)" }}
                        size={55}
                    />
                </div>
                <h1 className="text-center">
                    Erro
                </h1>
                <p className="tx-15 text-center tx-light">
                    Ocorreu um erro inesperado, por favor, tente novamente.
                </p>

                <div className="d-flex justify-content-center">
                    <Button className="btn btn-primary font-weight-bold rounded-md" onClick={() => setStep(eStep.IMPORT_EXCEL)}>
                        Tentar novamente
                    </Button>
                </div>
            </Modal.Body>
        }

    }

    if (isLoading) {
        return <Modal show={true}>
            <Modal.Body>
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                </div>
            </Modal.Body>
        </Modal>
    }

    return <Modal show={true} onHide={() => push('/')}>
        <Modal.Header>
            <Modal.Title as="h5">Carteira</Modal.Title>
            <AiOutlineClose
                onClick={() => push('/')}
                size={23}
                className="float-right cursor-pointer"
            />
        </Modal.Header>
        {modalBody()}
    </Modal>
}

function parseTolerance(tolerance: string): string {
    if (tolerance === 'low') {
        return 'BAIXA';
    }

    return 'ALTA';
}
